// removed by extract-text-webpack-plugin
module.exports = {"ssoLoginIframe":"SSOLoginIframe__ssoLoginIframe","dimmer":"SSOLoginIframe__dimmer","providerLogin":"SSOLoginIframe__providerLogin","providerLoginContent":"SSOLoginIframe__providerLoginContent","loginHeader":"SSOLoginIframe__loginHeader","close":"SSOLoginIframe__close","clearIcon":"SSOLoginIframe__clearIcon","iframe":"SSOLoginIframe__iframe","growDotQello":"SSOLoginIframe__growDotQello","growDotBlue":"SSOLoginIframe__growDotBlue","growDotGolden":"SSOLoginIframe__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SSOLoginIframe/SSOLoginIframe.scss
// module id = 1883
// module chunks = 0